<script>
import ModuleSimulatorConfigurationsComponent from '../../features/modules/ModuleSimulatorConfigurationsComponent';
import MainMenuView from '../../../shared/views/MainMenuView';
import PermissionHelper from '../../../../core/shared/helpers/PermissionHelper';

import ListSimulatorQuestionsView from '../lists/ListSimulatorQuestionsView';
import ListSimulatorQuestionCategoriesView from '../lists/ListSimulatorQuestionCategoriesView';
import PageHeaderView from '../../../shared/views/PageHeaderView';

export default {
  name: 'ModuleSimulatorConfigurationsView',
  components: {
    'page-header-view': PageHeaderView,
    'main-menu-view': MainMenuView,
    'list-simulator-questions-view': ListSimulatorQuestionsView,
    'list-simulator-question-categories-view': ListSimulatorQuestionCategoriesView,
  },
  extends: ModuleSimulatorConfigurationsComponent,
  data() {
    return {};
  },
  methods: {
    onCanShow(moduleName) {
      return PermissionHelper.canShow(moduleName);
    },
  },
};
</script>

<template>
  <div>
    <main-menu-view />
    <div class="wrapper">
      <div class="sa4d25">
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 col-lg-12">
              <div class="section3125">
                <page-header-view
                  icon="fas fa-sliders-h"
                  title="Configuración de Simuladores"
                  subtitle="Parámetros, tiempos y reglas de aplicación de cada simulador"
                />
                <div class="la5lo1">
                  <el-tabs
                    v-model="mainActiveTab"
                    type="border-card"
                  >
                    <el-tab-pane
                      label="Preguntas"
                      name="simulator-questions"
                    >
                      <list-simulator-questions-view v-if="mainActiveTab === 'simulator-questions'" />
                    </el-tab-pane>
                    <el-tab-pane
                      label="Categorias de Preguntas"
                      name="simulator-question-categories"
                    >
                      <list-simulator-question-categories-view v-if="mainActiveTab === 'simulator-question-categories'" />
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>